import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { LegalStatusClient, LegalStatusView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class LegalStatusService {
    constructor(private readonly client: LegalStatusClient) {}

    async getAll(): Promise<LegalStatusView[]> {
        return await lastValueFrom(this.client.legalStatusGetAll());
    }

    async getById(id: number): Promise<LegalStatusView> {
        return await lastValueFrom(this.client.legalStatusGetById(id));
    }
}
